import Vue from 'vue';

export const EVENT_BUS_TYPES = {
	LIVE_SALE_OPERATOR_UPDATE: 'live_sale_operator_update'
};

export const EVENT_BUS = new Vue();
